<template>
  <v-list dense>
    <v-list-item>
      <v-tooltip top nudge-right>
        <template v-slot:activator="{ on }">
          <v-btn icon @click="sendMail" v-on="on" large>
            <v-icon>mdi-email-outline</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("navigation.TheSettingsList.sendMail") }}</span>
      </v-tooltip>
      <v-tooltip top nudge-right>
        <template v-slot:activator="{ on }">
          <v-btn icon @click="toggle" v-on="on" large>
            <v-icon v-if="!darkMode">mdi-weather-night</v-icon>
            <v-icon v-if="darkMode">mdi-weather-sunny</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("navigation.TheSettingsList.toggleDarkMode") }}</span>
      </v-tooltip>
      <v-tooltip top nudge-right>
        <template v-slot:activator="{ on }">
          <v-btn icon @click="changeLanguage" v-on="on" large>
            <v-icon>mdi-web</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("navigation.TheSettingsList.toggleLanguage") }}</span>
      </v-tooltip>
      <v-tooltip top nudge-right v-if="isMintFuture">
        <template v-slot:activator="{ on }">
          <v-btn icon @click="submitRating" v-on="on" large>
            <v-icon>mdi-star-plus-outline</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("navigation.TheSettingsList.rate") }}</span>
      </v-tooltip>
    </v-list-item>
    <v-list-item class="py-0">
      <small class="text--secondary mx-2">v{{ version }}</small>

      <v-btn v-if="updateAvailable" text @click="update" x-small color="info" class="mx-2">
        <v-icon left>mdi-update</v-icon>
        <span>{{ $t("navigation.TheSettingsList.update") }}</span>
      </v-btn>
    </v-list-item>
    <language-dialog v-model="showLanguageSelectionDialog" @next="next" :language="local"></language-dialog>
  </v-list>
</template>

<script lang="ts">
import LanguageDialog from "@/components/utility/LanguageDialog.vue";
import { applyUpdate } from "@/registerServiceWorker";
import { PartnerTypeEnum } from "@/store/enum/partner/partner.type.enum";
import { ConfigModule } from "@/store/modules/config";
import { PartnerModule } from "@/store/modules/partner";
import { Component, Vue } from "vue-property-decorator";

@Component({ components: { LanguageDialog } })
export default class TheSettingsList extends Vue {
  showLanguageSelectionDialog = false;

  set debug(bo: boolean) {
    ConfigModule.setDebug(bo);
  }

  get debug() {
    return ConfigModule.debug;
  }

  get partner() {
    return PartnerModule.partner;
  }

  get local() {
    return this.$i18n.locale;
  }

  toggle() {
    this.darkMode = !this.darkMode;
  }

  sendMail() {
    const mailText = `mailto:${ConfigModule.supportMail}`;

    window.open(mailText, "_blank");
  }

  changeLanguage() {
    this.showLanguageSelectionDialog = true;
  }

  next() {
    this.showLanguageSelectionDialog = false;
  }

  set darkMode(bo: boolean) {
    ConfigModule.setDarkMode(bo);
  }

  get darkMode() {
    return ConfigModule.darkMode;
  }

  get isMintFuture(): boolean {
    return PartnerModule?.partner?.partnerType === PartnerTypeEnum.THG_WHITE_LABEL_MINT_FUTURE;
  }

  submitRating() {
    window.open(ConfigModule.googleThgRatingLink, "_blank");
  }

  get updateAvailable() {
    return ConfigModule.updateAvailable;
  }

  get version() {
    return ConfigModule.appVersion;
  }

  update() {
    applyUpdate();
  }
}
</script>

<style lang="scss" scoped>
v-card {
  max-width: 100%;
}
</style>
